import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import SimpleApiExplorer from '../components/SimpleApiExplorer';
import { useApiMode } from '../context/ApiModeContext';
import './PageStyles.css';

const Payments = () => {
  const { apiBaseUrl } = useApiMode();
  const [showTryApi, setShowTryApi] = useState(false);
  const payments = [
    { id: 'PAY001', customer: 'John Doe', amount: '$1,500', currency: 'USD', connection: 'Connection 1', status: 'Success', date: '2024-01-15', transactionId: 'TXN123456' },
    { id: 'PAY002', customer: 'Jane Smith', amount: '$2,300', currency: 'USD', connection: 'Connection 2', status: 'Success', date: '2024-01-15', transactionId: 'TXN123457' },
    { id: 'PAY003', customer: 'Bob Johnson', amount: '$850', currency: 'USD', connection: 'Connection 1', status: 'Pending', date: '2024-01-14', transactionId: 'TXN123458' },
    { id: 'PAY004', customer: 'Alice Brown', amount: '$3,200', currency: 'USD', connection: 'Connection 2', status: 'Success', date: '2024-01-14', transactionId: 'TXN123459' },
    { id: 'PAY005', customer: 'Charlie Wilson', amount: '$1,100', currency: 'USD', connection: 'Connection 1', status: 'Failed', date: '2024-01-13', transactionId: 'TXN123460' },
  ];

  const sampleRequest = {
    customer_id: "CUST001",
    amount: 1500.00,
    amount: 1500.00,
    currency: "USD",
    receiver_details: {
      name: "Jane Receiver",
      account_number: "1234567890",
      bank_name: "Bank of America"
    },
    payment_mode: "bank_transfer"
  };

  const sampleResponse = {
    status: "success",
    code: "200",
    message: "Payment initiated successfully",
    data: {
      payment_id: "PAY001",
      transaction_id: "TXN123456",
      customer_id: "CUST001",
      amount: 1500.00,
      currency: "USD",
      partner: "Veem",
      status: "pending",
      created_at: "2024-01-15T10:30:00Z"
    },
    request_id: "req_123456789"
  };

  const getOneResponse = {
    status: "success",
    code: "200",
    data: {
      payment_id: "PAY001",
      transaction_id: "TXN123456",
      customer_id: "CUST001",
      amount: 1500.00,
      currency: "USD",
      partner: "Veem",
      status: "success",
      created_at: "2024-01-15T10:30:00Z"
    },
    request_id: "req_123456789"
  };

  const getAllResponse = {
    status: "success",
    code: "200",
    data: [
      { payment_id: "PAY001", customer_id: "CUST001", amount: 1500, currency: "USD", status: "success" },
      { payment_id: "PAY002", customer_id: "CUST002", amount: 2300, currency: "USD", status: "success" },
    ],
    request_id: "req_123456789"
  };

  const transactionsTabs = [
    {
      id: 'get-one',
      label: 'Get transaction',
      method: 'GET',
      endpoint: '/api/v1/payments/{id}',
      pathParams: [{ name: 'id', placeholder: 'PAY001' }],
      sampleResponse: getOneResponse,
    },
    {
      id: 'get-all',
      label: 'Get all transactions',
      method: 'GET',
      endpoint: '/api/v1/payments',
      sampleResponse: getAllResponse,
    },
    {
      id: 'create',
      label: 'Create transaction',
      method: 'POST',
      endpoint: '/api/v1/payments',
      sampleRequest,
      sampleResponse,
    },
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Transactions</h2>
            <button type="button" className="btn btn-try-api" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>Payment ID</th>
                <th>Customer</th>
                <th>Amount</th>
                <th>Currency</th>
                <th>Connection</th>
                <th>Status</th>
                <th>Transaction ID</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment.id}>
                  <td>{payment.id}</td>
                  <td>{payment.customer}</td>
                  <td><strong>{payment.amount}</strong></td>
                  <td>{payment.currency}</td>
                  <td>{payment.connection}</td>
                  <td>
                    <span className={`status-badge ${payment.status.toLowerCase()}`}>
                      {payment.status}
                    </span>
                  </td>
                  <td><code>{payment.transactionId}</code></td>
                  <td>{payment.date}</td>
                  <td>
                    <button className="btn btn-success btn-sm">View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <SimpleApiExplorer
              apiName="Transactions API"
              tabs={transactionsTabs}
              baseUrl={apiBaseUrl}
              onClose={() => setShowTryApi(false)}
            />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Payments;
